import { observable, action } from 'mobx';

import { ConnectionAppManager, Variables } from 'core/index';

import { ContributionArrayApp, ContributorsApp } from 'apps/repository/app';
import { ContributionsQuery, ContributorsQuery } from 'apps/repository/gql';

export class ContributionConnManager extends ConnectionAppManager {
  static ArrayApp = ContributionArrayApp;
  constructor(parent, init) {
    super(parent, init);
    this.initialBatchSize = 5;
    this.batchSize = 10;
    this.variables = new Variables({
      projectId: () => this.projectId,
      batchSize: () => {
        if (this.loadedMore) {
          return this.batchSize;
        }
        return this.initialBatchSize;
      },
      cursor: () => this.endCursor,
      sortBy: () => 'recent',
    });
    this.loadMoreQuery = ContributionsQuery;
  }

  @action NewVariables() {
    this.Reset();
  }
}

export class ContributorConnManager extends ConnectionAppManager {
  static ArrayApp = ContributorsApp;
  @observable sortBy = 'recent';
  @observable sortOptions = [];
  constructor(parent, init) {
    super(parent, init);
    this.initialBatchSize = 6;
    this.batchSize = 6;
    this.variables = new Variables({
      projectId: () => this.projectId,
      sortBy: () => this.sortBy,
      batchSize: () => {
        if (this.loadedMore) {
          return this.batchSize;
        }
        return this.initialBatchSize;
      },
      cursor: () => this.endCursor,
    });
    this.loadMoreQuery = ContributorsQuery;
  }

  @action NewVariables() {
    this.Reset();
  }
  // @action SetSort(sort) {
  //   this.sortBy = sort;
  //   this.Clear();
  //   this.loadMore();
  // }
}
